import { useEffect, useState } from 'react';

import { useAclVersion } from '@/hooks/useSessionRefresh';
import { getApiCall } from '@/service/httpCall';
import { API_CONTACT_CUSTOM_FIELDS_ACCESS } from '@/service/url';

// One request per session; dropped when the ACL refreshes.
let cached: Promise<boolean> | null = null;
if (typeof window !== 'undefined') {
  window.addEventListener('acl-refreshed', () => {
    cached = null;
  });
}

function fetchVisible(): Promise<boolean> {
  if (!cached) {
    cached = getApiCall(API_CONTACT_CUSTOM_FIELDS_ACCESS, {})
      .then((resp: unknown) => Boolean((resp as { enabled?: boolean } | null)?.enabled))
      .catch(() => {
        cached = null;
        return false;
      });
  }
  return cached;
}

/**
 * Whether Customer Additional Details (contact custom fields) show anywhere for this user.
 * Agents and team leads follow their call centre's Contacts → Custom fields ACL option,
 * which the backend resolves. False until the answer arrives.
 */
export function useCustomFieldsVisible(): boolean {
  const aclVersion = useAclVersion();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let alive = true;
    void fetchVisible().then((v) => {
      if (alive) setVisible(v);
    });
    return () => {
      alive = false;
    };
  }, [aclVersion]);

  return visible;
}
